// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";
import { getToken } from "./localStorageService";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const userApi = baseApi.injectEndpoints({
  credentials: "include",
  // tagTypes: ['User'],
  // global configuration for the api
  // refetchOnFocus: true,
  endpoints: (builder) => ({
    // addUser: builder.mutation({
    //   query: (user) => {
    //     return {
    //       url: "add_user",
    //       method: "POST",
    //       body: user,
    //       headers: {
    //         "Content-type": "application/json; charset=UTF-8",
    //         authorization: `Bearer ${getToken()}`,
    //       },
    //     };
    //   },
    //   // invalidatesTags: ['User'],
    // }),
    // updateUser: builder.mutation({
    //   query: (user) => {
    //     return {
    //       url: "update_user",
    //       method: "POST",
    //       body: user,
    //       headers: {
    //         "Content-type": "application/json; charset=UTF-8",
    //         authorization: `Bearer ${getToken()}`,
    //       },
    //     };
    //   },
    //   // invalidatesTags: ['User'],
    // }),
    deleteUser: builder.mutation({
      query: (id) => {
        return {
          url: `user/${id}`,
          method: "DELETE",
          // body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            authorization: `Bearer ${getToken()}`,
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    getAllUsers: builder.query({
      query: (params) => {
        const queryParams = new URLSearchParams(params).toString();
        return {
          url: `get-all-users?${queryParams}`,
          method: "GET",
          // headers: {
          //   "Content-type": "application/json; charset=UTF-8",
          //   authorization: `Bearer ${getToken()}`,
          // },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    changeUserPass: builder.mutation({
      query: ({ data, id }) => {
        return {
          url: `change-user-password/${id}`,
          method: "POST",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      invalidatesTags: ["User"],
    }),

    blockUnblockUser: builder.mutation({
      query: ({ id }) => {
        return {
          url: `/block-user/${id}`,
          method: "PUT",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    getUserContentAnalytics: builder.query({
      query: (params) => {
        const queryParams = new URLSearchParams(params).toString();
        return {
          url: `content-actions/content-analytics?${queryParams}`,
          method: "GET",
          // headers: {
          //   "Content-type": "application/json; charset=UTF-8",
          //   authorization: `Bearer ${getToken()}`,
          // },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    getBusinessProfile: builder.query({
      query: (params) => {
        const queryParams = new URLSearchParams(params).toString();
        return {
          url: `business-profiles?${queryParams}`,
          method: "GET",
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
    }),
    getBusinessProfileList: builder.query({
      query: (query) => {
        let queryString = new URLSearchParams({
          orderBy: "name",
          order: "ASC",
        }).toString();
        return {
          url: `business-profiles/profiles?${queryString}`, // todo:
          method: "GET",
        };
      },
      transformResponse: (response) => {
        // Extract only id and name
        return response.data
          .filter((item) => item.name && item.name.trim() !== "")
          .map((item) => ({
            value: item.id,
            label: item.name,
          }));
      },
      keepUnusedDataFor: 300, // keep cached data for 5 minutes (in seconds) means after 5 mint cache clean it only
      refetchOnFocus: true,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useDeleteUserMutation,
  useGetAllUsersQuery,
  useChangeUserPassMutation,
  useBlockUnblockUserMutation,
  useGetUserContentAnalyticsQuery,
  useGetBusinessProfileQuery,
  useGetBusinessProfileListQuery, // for Filter List 
} = userApi;
